__turbopack_context__.v({
  "arrow": "headerLinks-module-scss-module__oW-JmW__arrow",
  "label": "headerLinks-module-scss-module__oW-JmW__label",
  "menu": "headerLinks-module-scss-module__oW-JmW__menu",
  "trigger": "headerLinks-module-scss-module__oW-JmW__trigger",
});
